import {BaseDtoModel} from '../../Services/Models/base-model.service';

export class AppConfigDto extends BaseDtoModel {
  language!: string;
  multisession!: {
    active: boolean,
    locked_automatic: boolean,
    locked_logout: boolean,
    force_modal: boolean,
  };

  constructor(dataJson?: any) {
    super(dataJson);

    this.init({
      language: 'es',
      multisession: {
        active: false,
        locked_automatic: false,
        locked_logout: false,
        force_modal: false,
      },
    });
  }
}
